import { takeLatest, call, put } from "redux-saga/effects";

import AuthService from "../../../services/Auth/AuthService";
import * as types from "../actionTypes";
import { workerSaga as getClientsWorkerSaga } from "../../client/sagas/GetClientsSaga";

export function* userLoginWatcherSaga() {
  yield takeLatest(types.AUTH_API_LOGIN_REQUEST, workerSaga);
}

export function* workerSaga({ email, password, res, rej, isLoggedIn }) {
  let loginError = null;
  try {
    const data = yield call(AuthService.login, email, password);
    yield put({
      type: types.AUTH_API_LOGIN_SUCCESS,
      payload: { ...data },
    });
    isLoggedIn.current = true;
    if (!data.isVoiceTalent) {
      const { tooManyClients, error } = yield call(getClientsWorkerSaga);
      if (error) {
        loginError = error;
      } else {
        if (tooManyClients) {
          yield call(AuthService.logout);
          isLoggedIn.current = false;
        }
        res(tooManyClients);
      }
    }
    res(false);
  } catch (error) {
    loginError = error;
  }

  if (loginError) {
    yield put({ type: types.AUTH_API_LOGIN_FAILURE });
    if (isLoggedIn.current) {
      call(AuthService.logout);
      isLoggedIn.current = false;
    }
    rej(loginError);
  }
}
